import { render, staticRenderFns } from "./Stage3.vue?vue&type=template&id=f9ad23d2&scoped=true&"
import script from "./Stage3.vue?vue&type=script&lang=js&"
export * from "./Stage3.vue?vue&type=script&lang=js&"
import style0 from "./Stage3.vue?vue&type=style&index=0&id=f9ad23d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ad23d2",
  null
  
)

export default component.exports